const deliveryTypeAndDateTimeMapper = require('./atmmapper/delivery-timetable-analytics-mapper.js');
const changeFulfilmentMethodMapper = require('./atmmapper/change-fulfilment-method-mapper');
const notifyMeMapper = require('./atmmapper/notify-me-analytics-mapper');
const firstAvailableWindowMapper = require('./atmmapper/first-available-window-mapper');

/**
 * Delivery Service
 * @param $rootScope
 * @param restangular
 * @param trolleyService
 * @param addressService
 * @param settingsService
 * @param $timeout
 * @param $log
 * @param atm
 * @param checkoutService
 * @param shopperService
 * @constructor
 */
const DeliveryService = function ($rootScope, restangular, trolleyService, addressService, settingsService, $timeout, $log, atm, shopperService) {
    this.rootScope = $rootScope;
    this.shopperService = shopperService;

    this.$log = $log;
    this.deliveryOptions = {
        delivery: { name: 'delivery', text: 'Delivery', value: 'Delivery' },
        collect: { name: 'collect', text: 'Pick up', value: 'Pick Up', selected: true }
    };

    this.checkoutDeliveryOptions = {
        delivery: this.deliveryOptions.delivery,
        collect: this.deliveryOptions.collect
    };

    this._deliveryApi = restangular.all('DeliveryWindows');
    this._pickupApi = restangular.all('PickupWindows');
    this._deliveryInfoApi = restangular.one('Delivery');

    this.timeTable = undefined;
    this.nextDeliveryETA = null;
    this.nextDeliveryETATime = null;
    this.nextDeliveryIsToday = null;
    this.isDeliveryInOneHour = false;
    this.timeTableForStore = undefined;
    this.nextAvailableDeliveryETAForStore = null;
    this.nextDeliveryETAForStore = null;
    this.hideAsapOption = false;
    this.selectedDeliveryDateAndTime = '';
    this.deliveryMethodType = '';

    this.trolleyService = trolleyService;
    this.addressService = addressService;

    this.canReviewOrder = false;
    this.isRecipientIdCheckRequired = false;
    this.isIdVerificationRequired = false;
    this.deliveryMethod(this.deliveryOptions.collect);
    this.savedDeliveryMethod = this.deliveryOptions.collect;

    // this.deliveryFeeStructure = null;
    this.dateTimeCleared = true;
    this.settingsService = settingsService;
    this.timeout = $timeout;
    this.atm = atm;

    const self = this;
    this.settingsService.getSettingValue('DeliveryWindowAlerts', 'ReservationExpiredAlertMessage').then(function (msg) { self.expiredAlertMessage = msg; });
    this.settingsService.getSettingValue('DeliveryWindows', 'ReservationTimeout').then(function (minutes) { self.reservationTimeout = minutes; });
    this.settingsService.getSettingValue('DeliveryWindowAlerts', 'ClosingSoonAlertPeriod').then(function (minutes) { self.closingSoonAlertPeriod = minutes; });
    this.settingsService.getSettingValue('DeliveryWindowAlerts', 'ClosingNowAlertPeriod').then(function (minutes) { self.closingNowAlertPeriod = minutes; });
    this.settingsService.getSettingValue('DeliveryWindowAlerts', 'ClosingSoonAlertMessage').then(function (msg) { self.closingSoonAlertMessage = msg; });
    this.settingsService.getSettingValue('DeliveryWindowAlerts', 'ClosingNowAlertMessage').then(function (msg) { self.closingNowAlertMessage = msg; });
    this.settingsService.getSettingValue('DeliveryWindowAlerts', 'ClosedAlertMessage').then(function (msg) { self.closedAlertMessage = msg; });
};

DeliveryService.prototype.deliveryMethod = function (deliveryMethod) {
    // getter-setter
    if (deliveryMethod !== undefined) {
        this.selectedDeliveryMethod = deliveryMethod;
        this.rootScope.$broadcast('delivery-deliveryMethodChange');
    }

    return this.selectedDeliveryMethod;
};

DeliveryService.prototype.isDelivery = function () {
    return this.selectedDeliveryMethod.name === this.checkoutDeliveryOptions.delivery.name;
};

DeliveryService.prototype.isPickup = function () {
    return this.selectedDeliveryMethod.name === this.checkoutDeliveryOptions.collect.name;
};

DeliveryService.prototype.setDeliveryType = function (type) {
    this.deliveryMethodType = type;

    return this.deliveryMethodType;
};

DeliveryService.prototype.isStandardDelivery = function () {
    return this.deliveryMethodType === 'standard';
};

DeliveryService.prototype.isExpressDelivery = function () {
    return this.deliveryMethodType === 'express';
};

DeliveryService.prototype.setCanReviewOrder = function (canReviewOrder) {
    this.canReviewOrder = canReviewOrder;
};

//--------------- New BWS APIs for On Demand Delivery -------------//

DeliveryService.prototype.isDeliveryAvailable = function (data) {
    return this._deliveryInfoApi.one('DeliveryAvailability').get({ Postcode: data.postcode, Suburb: data.suburb });
};

DeliveryService.prototype.transformNExtDeliveryEta = function (data) {
    if (!data) {
        return null;
    }

    //reset hide ASAP option
    this.hideAsapOption = false;
    try {
        let mins = Math.ceil(data.Minutes / 5) * 5;
        let hrs = data.Hours;
        const days = data.Days;
        const isHoursLessThanOne = hrs === 0;
        let asapTime;

        //move minutes to the hour
        if (mins === 60) {
            hrs = hrs + 1;
            mins = 0;
        }

        if (days > 0 || hrs >= 3 || hrs === 0 && mins < 15) {
            this.hideAsapOption = true;
        } else if (mins === 0) {
            asapTime = hrs === 1 ? hrs + 'hr' : hrs + 'hrs';
        } else if (mins < 60) {
            asapTime = isHoursLessThanOne ? mins + 'mins' : hrs + 'hr' + (hrs === 1 ? ' ' : 's ') + mins + 'mins';
        } else {
            asapTime = hrs + 'hrs';
        }

        return asapTime;
    } catch (e) {
        this.$log.log(e, 'There are no delivery windows enabled for this store');
    }

};
DeliveryService.prototype.transformNextDeliveryTime = function (data) {
    if (!data) {
        return null;
    }

    const split = data.split(':');
    if (split.length > 1) {
        const hour = split[0];
        const suffix = hour >= 12 ? 'pm' : 'am';
        const formattedHour = hour > 12 ? hour - 12 : hour;
        return formattedHour + ':' + split[1] + ' ' + suffix;
    }

    return null;
};

//
DeliveryService.prototype.getDeliveryWindows = function (dto) {

    this.timeTable = undefined;
    this.isASAPEnabled = false;
    this.nextDeliveryETA = undefined;
    return this._deliveryInfoApi.one('DeliveryWindowForCurrentDeliveryStore')
       .get(dto)
       .then((res) => {

           this.deliveryWindowsRes = res;
           this.deliveryErrorMessage = '';
           this.timeTable = res.DeliveryWindows;
           this.isASAPEnabled = res.IsASAPEnabled;
           this.nextAvailableDeliveryRealTimeEta = res.NextAvailableDeliveryRealTimeEta;
           this.nextDeliveryETA = this.transformNExtDeliveryEta(res.NextAvailableDeliveryETAInTimeSplit);
           this.nextDeliveryETATime = this.transformNextDeliveryTime(res.NextAvailableDeliveryAt.NextDeliveryAtTime);
           this.nextDeliveryIsToday = new Date().getDate() === Number(res.NextAvailableDeliveryAt.NextDeliveryAtDate.split('-')[2]);
           this.isDeliveryInOneHour = res.NextAvailableDeliveryETAInTimeSplit && res.NextAvailableDeliveryETAInTimeSplit.Hours < 1;
        }, (res) => {
            this.deliveryErrorMessage = res.data.Message;
   });
};

DeliveryService.prototype.getDeliveryWindowsForStore = function (dto) {
    return this._deliveryInfoApi.one('DeliveryWindow')
        .get(dto)
        .then((res) => {

            this.timeTableForStore = res.DeliveryWindows;
            this.nextAvailableDeliveryRealTimeEta = res.NextAvailableDeliveryRealTimeEta;
            this.isASAPEnabled = res.IsASAPEnabled;
            this.nextAvailableDeliveryETAForStore = res.NextAvailableDeliveryETAIn;
            this.nextDeliveryETAForStore = this.transformNExtDeliveryEta(res.NextAvailableDeliveryETAInTimeSplit);
            this.isDeliveryInOneHour = res.NextAvailableDeliveryETAInTimeSplit && res.NextAvailableDeliveryETAInTimeSplit.Hours < 1;
        });
};

DeliveryService.prototype.setDeliveryTypeAndDate = function (deliveryDetails) {

    return this._deliveryInfoApi.one('SetDeliveryTypeAndDateTime').doPOST(deliveryDetails)
        .then(res => {
            this.isIdVerificationRequired = res ? res.IsIdVerificationRequired : false;
            return res;
        });
};

DeliveryService.prototype.setDeliveryRsaInfo = function (isRecipientIdCheckRequired) {
    const obj = {
        IsRecipientIdCheckRequired: isRecipientIdCheckRequired
    };
    return this._deliveryInfoApi.one('DeliveryRsaInfo').doPOST(obj);
};

DeliveryService.prototype.isGuestTheRecipient = function (isGuestTheRecipient, callShopper) {
    const obj = {
        Value: isGuestTheRecipient
    };
    this._deliveryInfoApi.one('IsGuestTheRecipient').doPOST(obj).then(() => {
        if (callShopper) {
        // calling shopper is a dependency
            this.shopperService.getCurrentShopperDetails();
        }
    });
};

DeliveryService.prototype.setIsRecipientIdCheckRequired = function (isRecipientIdCheckRequired) {
    this.isRecipientIdCheckRequired = isRecipientIdCheckRequired;
};

DeliveryService.prototype.getIsRecipientIdCheckRequired = function () {
    return this.isRecipientIdCheckRequired;
};

/**
 * Modify an existing booking
 * @param dto
 * @returns {*}
 */
DeliveryService.prototype.modifyDeliveryBooking = function (dto) {
    const modifyRequest = {
        BookingReference: dto.bookingRef,
        DeliveryAtWindowDate: dto.WindowDate,
        DeliveryAtWindowTime: dto.WindowTime ? dto.WindowTime : dto.WindowRange.ActualTime
    };
    if (!dto.WindowTime && dto.WindowRange) { //dto has windowRange
        modifyRequest.WindowRange = {
            StartTime: dto.WindowRange.StartTime,
            EndTime: dto.WindowRange.EndTime
        };
    }

    return this._deliveryInfoApi.one('ModifyDeliveryBooking').customPUT(modifyRequest);
};

DeliveryService.prototype.sendAnalyticsForDeliveryType = function (data) {
    Object.assign(data, this.selectedDeliveryDateAndTime);

    this.atm.push(data, deliveryTypeAndDateTimeMapper);
};

DeliveryService.prototype.sendAnalyticsForInvalidWindow = function (area) {
    const data = Object.assign({ event: 'BWSAUinvalidWindow', area }, this.selectedDeliveryDateAndTime);
    this.atm.push(data, deliveryTypeAndDateTimeMapper);
};

DeliveryService.prototype.sendAnalyticsChangeFulfilmentMethod = function (fulfilmentMethod) {
    this.atm.push(fulfilmentMethod, changeFulfilmentMethodMapper);
};

DeliveryService.prototype.sendAnalyticsNotifyMe = function (data) {
    this.atm.push(data, notifyMeMapper);
};

DeliveryService.prototype.sendAnalyticFirstAvailableWindow = function (area) {
    this.atm.push(area, firstAvailableWindowMapper);
};

module.exports = DeliveryService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/delivery/delivery-service.js
 **/